import React from 'react'
import MuiChip from '@material-ui/core/Chip'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import { translate } from '../../multilanguage'

const ChipBase = props => {
  const { backgroundColor, textColor, fontSize, noTranslate, ...finalProps } = props
  
  return <MuiChip {...finalProps} />
}

ChipBase.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   Text color for the chip for non standard colors.
   */
  textColor: PropTypes.string,
  /**
   Background cpolor for the chip for non standard colors.
   */
  backgroundColor: PropTypes.string,
  /**
   Font size for label of the chip.
   */
  fontSize: PropTypes.string,
  /**
   Prevents the language translation of the label.
   */
  noTranslate: PropTypes.bool,
}

const StyledMuiChip = withStyles(() => ({
  root: {
    backgroundColor: props => props.backgroundColor,
    color: props => props.textColor,
    fontSize: props => props.fontSize,
  }
}))(ChipBase)

/**
 * Implements Mui Chip.
 *
 * @param {object} props component props
 * @returns {Chip} Chip component
 */
const Chip = props => {
  return (
    <StyledMuiChip {...props} label={props.noTranslate ? props.label : translate(props.label)} />
  )
}

Chip.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   MUI color for the Chip.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),
  /**
   Determines the Chip size.
   */
  size: PropTypes.oneOf(['small', 'medium']),
  /**
   Determines the Chip style.
   */
  variant: PropTypes.oneOf(['default', 'outlined']),
  /**
   Function that is executed when the badge is clicked.
   */
  label: PropTypes.string,
  /**
   Function that is executed when the badge is clicked.
   */
  onClick: PropTypes.func,
  /**
   Text color for the chip for non standard colors.
   */
  textColor: PropTypes.string,
  /**
   Background color for the chip for non standard colors.
   */
  backgroundColor: PropTypes.string,
  /**
   Font size for label of the chip.
   */
  fontSize: PropTypes.string,
  /**
   Prevents the language translation of the label.
   */
  noTranslate: PropTypes.bool,
}

export default Chip